import { Feature } from '../features';
import { ConsentRTM } from './ConsentRTM';
import { OffsiteRulesets } from './OffsiteRulesets';
import { RulesetTemplate } from './template';

const TypeToTemplateMap: { [key in Feature]: RulesetTemplate[] } = {
  TestFeature1: [],
  TestFeature2: [],
  'Marketing Permission': [
    ConsentRTM.OptIn,
    ConsentRTM.ConfirmedOptIn,
    ConsentRTM.OptOut,
    ConsentRTM.SmsOptIn,
    ConsentRTM.SmsOptOut,
  ],
  'Cart Abandonment': [OffsiteRulesets.CartAbandonment],
  'Browse Abandonment': [OffsiteRulesets.BrowseAbandonment],
};

export const getTemplateList = (type: Feature): RulesetTemplate[] => {
  return TypeToTemplateMap[type] || [];
};
